interface Props {
  titulo: string;
  mensagem: string;
  textoConfirmar: string;
  salvando: boolean;
  aoConfirmar: () => void;
  aoCancelar: () => void;
}

export default function ModalConfirmarAcao({
  titulo,
  mensagem,
  textoConfirmar,
  salvando,
  aoConfirmar,
  aoCancelar,
}: Props) {
  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/30 sm:items-center sm:p-6">
      <div className="animate-modal-pop w-full max-w-sm rounded-t-lg bg-white p-6 sm:rounded-lg">
        <div className="flex justify-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100">
            <i className="ri-question-line text-2xl text-primary-600" />
          </span>
        </div>
        <h3 className="mt-4 text-center text-lg font-medium text-foreground-950">{titulo}</h3>
        <p className="mt-2 text-center text-sm text-secondary-500">{mensagem}</p>
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={aoCancelar}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            Voltar
          </button>
          <button
            type="button"
            onClick={aoConfirmar}
            disabled={salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:opacity-60"
          >
            {salvando ? 'Salvando…' : textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}